module.exports = __webpack_public_path__ + "static/NeedSomething-e2e437d809ad32b368ceb4b89b0e14e0.jpg";